// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1eFqI","left":"StickyBox_left__2UyuT","right":"StickyBox_right__C98fv"};